import { Carousel, CarouselOptions } from '../objects/carousel';
import { LightBoxElement } from "../objects/light-box";
export const CLASS_OPEN = 'is-bundle-builder-open';
import {
  SliderData
} from "./types";


const template = document.createElement('template');
template.innerHTML = `
  <style>
    :host {
      display: block;
    }

    .c-image-slider__content-wrapper {
      display: flex;
      justify-content: center;
    }

    .c-image-slider__carousel-container {
      position: relative;
      overflow: hidden;
      width: 100%;
    }

    .c-image-slider__item-inner {
      width: 100%;
      height: 0;
      position: relative;
      padding-bottom: min(95%, calc(100vh - 21.875rem));
    }

    .c-image-slider__carousel {
      display: flex;
      flex-wrap: nowrap;
      border-radius: 1rem;
      overflow: hidden;
      position: relative;
    }

    .c-image-slider__item {
      width: 100%;
      min-width: 100%;
      border-radius: 1rem;
      overflow: hidden;
    }

    .c-image-slider__item-inner img {
      width: 100%;
      height: 100%;
      position: absolute;
      object-fit: cover;
    }

    .c-image-slider__nav {
      position: absolute;
      top: 50%;
      transform: translateY(calc(-50% - 2.6875rem));
      display: none;
      justify-content: space-between;
      left: 0.75rem;
      right: 0.75rem;
    }

    .c-image-slider__nav-button {
      background: none;
      border: none;
      padding: 0;
      pointer-events: none;
    }

    .c-image-slider__nav-button.is-prev {
      transform: rotate(180deg);
    }

    .c-image-slider__nav-button svg {
      width: 1.5rem;
      height: 1.5rem;
    }

    .c-image-slider__nav-button svg path {
      stroke: #FCFCFB;
    }

    .c-image-slider__thumbs {
      display: flex;
      gap: 0.5rem;
      margin-top: 1rem;
      justify-content: center;
    }

    .c-image-slider__thumb {
      padding: 0;
      width: 3.75rem;
      height: 3.75rem;
      border: none;
      border-radius: 0.75rem;
      overflow: hidden;
      transition: padding 0.3s;
      cursor: pointer;
    }

    .c-image-slider__thumb.is-thumb-active {
      padding: 0.375rem;
      border: 0.0625rem solid #163021;
    }

    .c-image-slider__thumb.is-thumb-active img {
      border-radius: 0.5rem;
    }

    .c-image-slider__thumb img {
      width: 100%;
      height: 100%;
    }

    .c-image-slider__model-viewer-toggle {
      display: flex;
      align-items: center;
      border-radius: 1.5rem;
      border: none;
      background: #D1E6C7;
      color: #163021;
      padding: 0.75rem 1.5rem 0.75rem 0.6875rem;
      margin: 1.375rem auto -1.25rem;
    }

    .c-image-slider__model-viewer-toggle-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 0.6875rem;
      padding-bottom: 0.0625rem;
      width: 1.125rem;
      height: 1.125rem;
    }

    .c-image-slider__model-viewer-toggle-text {
      display: flex;
      align-items: center;
      font-size: 0.8125rem;
      line-height: 1.25rem;
      font-weight: 400;
    }

    .c-image-slider__zoom-btn {
      width: 1.75rem;
      height: 1.75rem;
      background: #e7edf1;
      border-radius: 50%;
      position: absolute;
      top: 0.75rem;
      right: 0.75rem;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s;
      color: black;
      padding: 0.0625rem 0.375rem;
    }

    .c-image-slider__zoom-btn svg {
      width: 100%;
      height: 100%;
    }

    .c-image-slider__zoom-btn:hover {
      background-color: white;
    }

    @media only screen and (max-width: 1099px) {
      :host {
        position: sticky;
        top: 0;
        z-index: 2;
        background: #fcfcfb;
        padding: 4.7rem 2rem 2rem;
        padding-bottom: .125rem;
        border-radius: 0 0 2rem 2rem;
        transition: transform 1.4s cubic-bezier(.16,1,.3,1);
      }

      :host(.summary-in-view) {}

      .is-show {
        display: none;
      }

      :host(.is-minimised) .is-hide {
        display: none;
      }

      :host(.is-minimised) .is-show {
        display: block;
      }

      :host(.is-minimised) .c-image-slider__content-wrapper {
        height: 0;
      }
    }

    @media only screen and (min-width: 1100px) {
      :host {
        border-radius: 1.75rem;
        background: #FCFCFB;
        position: fixed;
        top: 2.5rem;
        width: 27.75rem;
        right: 2.5rem;
        bottom: 2.5rem;
        transition: all 0.3s;
        padding: 0.25rem;
      }

      .c-image-slider__item {
        border-radius: 1.5rem;
      }

      .c-image-slider__nav {
        display: flex;
      }

      .c-image-slider__nav-button {
        pointer-events: auto;
        cursor: pointer;
      }

      .c-image-slider__model-viewer-toggle {
        display: none;
      }

      .c-image-slider__thumbs {
        gap: 0.625rem;
        margin-top: 1rem;
        justify-content: center;
      }

      .c-image-slider__thumb {
        width: 5.375rem;
        height: 5.375rem;
        border-radius: 1rem;
      }

      .c-image-slider__zoom-btn {
        width: 2.0625rem;
        height: 2.0625rem;
        top: 1.25rem;
        right: 1.25rem;
      }
    }

    @media only screen and (min-width: 1750px) {
      :host {
        top: 3rem;
        right: 3rem;
        bottom: 3rem;
        width: 38.5rem;
      }
    }
  </style>

  <div class="c-image-slider__model-viewer" part="root">
    <div class="c-image-slider__content-wrapper">
      <div class="c-image-slider__carousel-container">
        <div class="c-image-slider__carousel" data-image-carousel></div>

        <div class="c-image-slider__nav" data-carousel-nav>
          <button class="c-image-slider__nav-button is-prev o-btn is-arrow" data-carousel-previous>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="m7.5 5 5 5-5 5"></path></svg>
          </button>

          <button class="c-image-slider__nav-button is-next o-btn is-arrow" data-carousel-next>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="m7.5 5 5 5-5 5"></path></svg>
          </button>
        </div>

        <button class="c-image-slider__zoom-btn" data-lightbox-trigger>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="black"><path d="M3.8 20.3v-5.5m0 5.5h5.5m-5.5 0L10 14M20.3 3.8h-5.5m5.5 0v5.5m0-5.5L14 10"/></svg>
        </button>

        <div class="c-image-slider__thumbs has-js" data-product-gallery-thumbnails></div>
      </div>
    </div>

    <button class="c-image-slider__model-viewer-toggle" data-model-viewer-toggle>
      <span class="c-image-slider__model-viewer-toggle-icon">
        <svg class="is-show" xmlns="http://www.w3.org/2000/svg" width="19" height="17" fill="none">
          <g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
            <path d="m3.875 2.656 11.25 11.688M11.392 10.466a2.913 2.913 0 0 1-2.026.688 2.883 2.883 0 0 1-1.947-.867 2.57 2.57 0 0 1-.729-1.913 2.6 2.6 0 0 1 .918-1.84M10.03 5.89a2.859 2.859 0 0 1 1.552.823c.41.425.661.965.719 1.537"/>
            <path d="M15.168 11.23C16.7 9.932 17.375 8.5 17.375 8.5S15.125 3.719 9.5 3.719c-.487 0-.973.036-1.454.111M5.703 4.555C2.836 5.926 1.625 8.5 1.625 8.5s2.25 4.781 7.875 4.781a8.704 8.704 0 0 0 3.797-.837"/>
          </g>
        </svg>
        <svg class="is-hide" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
          <g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10 4.375C3.75 4.375 1.25 10 1.25 10s2.5 5.625 8.75 5.625S18.75 10 18.75 10 16.25 4.375 10 4.375Z"/>
            <path d="M10 13.125a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"/>
          </g>
        </svg>
      </span>
      <span class="c-image-slider__model-viewer-toggle-text">
        <span class="is-hide">Hide model</span>
        <span class="is-show">Show model</span>
      </span>
    </button>

    <light-box data-image-lightbox>
      <div class="o-lightbox-modal">
        <div class="o-lightbox-modal__image-container" data-image-container></div>
      </div>
    </light-box>
  </div>
`;

const SELECTOR_CAROUSEL = '[data-image-carousel]';
const SELECTOR_CAROUSEL_PREV = '[data-carousel-previous]';
const SELECTOR_CAROUSEL_NEXT = '[data-carousel-next]';
const SELECTOR_CAROUSEL_THUMBNAILS = '[data-product-gallery-thumbnails]';
const SELECTOR_CAROUSEL_THUMBNAIL = '[data-product-gallery-thumbnail]';
const SELECTOR_IMAGE_LIGHTBOX = "[data-image-lightbox]";
const SELECTOR_LIGHTBOX_TRIGGER = "[data-lightbox-trigger]";
const SELECTOR_LIGHTBOX_CLOSE = "[data-lightbox-close]";
const SELECTOR_LIGHTBOX_IMAGE_CONTAINER = "[data-image-container]";
const CAROUSEL_OPTIONS = {
  "slidesPerView": 1,
  "spacing": 16,
  "centered": true
}

export class CustomiserImageSlider extends HTMLElement {
  private toggleButton;
  private isOpen;

  private imageCarousel: HTMLElement | null = null;
  private prev: HTMLElement | null = null;
  private next: HTMLElement | null = null;
  private thumbnails: HTMLDivElement | null = null;
  private thumbnailsSlider: Carousel | null = null;
  private thumbnail: NodeListOf<HTMLElement> | null = null;
  private carousel:Carousel|null = null;
  private carouselOptions: CarouselOptions|{} = {};
  private sliderDataAttr:string|null;
  private sliderData:SliderData|null;
  private imageLightbox: LightBoxElement | null = null;
  private lightboxCta: HTMLElement | null = null;
  private lightboxImage: HTMLElement | null = null;
  private close: HTMLElement | null = null;

  constructor() {
    super();

    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));

    this.imageCarousel = shadowRoot.querySelector(SELECTOR_CAROUSEL);
    this.carouselOptions = CAROUSEL_OPTIONS;
    this.sliderDataAttr = this.getAttribute('slider-data');
    this.sliderData = this.sliderDataAttr ? JSON.parse(this.sliderDataAttr) : {};

    this.toggleButton = shadowRoot.querySelector('[data-model-viewer-toggle]');
    this.thumbnails = shadowRoot.querySelector(SELECTOR_CAROUSEL_THUMBNAILS);

    this.imageLightbox = shadowRoot.querySelector<LightBoxElement>(SELECTOR_IMAGE_LIGHTBOX);
    this.lightboxCta = shadowRoot.querySelector<HTMLElement>(SELECTOR_LIGHTBOX_TRIGGER);
    this.lightboxImage = shadowRoot.querySelector<HTMLElement>(SELECTOR_LIGHTBOX_IMAGE_CONTAINER);
    this.close = shadowRoot.querySelector<HTMLElement>(SELECTOR_LIGHTBOX_CLOSE);

    // Bind the event listener for the toggle button
    this.toggleButton?.addEventListener('click', () => {
      this.toggleModelViewer();
    });

    this.lightboxCta?.addEventListener("click", this.openLightbox.bind(this));

    this.close?.addEventListener("click", (e) => {
      this.onLightboxClose(e);
    });

    window.addEventListener("resize", () => {
      this.initSlider();
    });
  }

  public updateSlider(sliderData: SliderData | null = this.sliderData) {
    if (!sliderData || !this.imageCarousel) return;
  
    // Clear existing slides
    this.imageCarousel.innerHTML = '';
  
    let index = 0;
    for (const key in sliderData) {
      const imageUrl = sliderData[key];
      if (!imageUrl) continue;
  
      const slide = document.createElement('div');
      slide.classList.add('c-image-slider__item');
  
      slide.innerHTML = `
        <div class="c-image-slider__item-inner">
          <img src="${imageUrl}" alt="Slider image ${index + 1}" />
        </div>
      `;
  
      this.imageCarousel.appendChild(slide);
      index++;
    }

    // Set thumbnails
    this.setThumbnails(sliderData);
  
    // Re-initialize the carousel after setting new slides
    this.initSlider();
  }

  public initSlider() {
    this.prev = this.shadowRoot?.querySelector(SELECTOR_CAROUSEL_PREV) || null;
    this.next = this.shadowRoot?.querySelector(SELECTOR_CAROUSEL_NEXT) || null;
    this.thumbnail = this.shadowRoot?.querySelectorAll(SELECTOR_CAROUSEL_THUMBNAIL) || null;

    if (this.imageCarousel) {
      this.carousel?.dispose();
      this.carousel = new Carousel(this.imageCarousel, {
        loop: true,
        ...this.carouselOptions
      });
    }

    if (this.prev) this.carousel?.addPrevButton(this.prev);
    if (this.next) this.carousel?.addNextButton(this.next);
    
    if (this.thumbnail) {
      this.thumbnail.forEach(thumb => {
        this.carousel?.addThumbnails(thumb);
      });
    }
  }

  private setThumbnails(sliderData: SliderData | null = this.sliderData) {
    if (!sliderData || !this.thumbnails) return;
  
    // Clear existing thumbnails
    this.thumbnails.innerHTML = '';
  
    let index = 0;
    for (const key in sliderData) {
      const imageUrl = sliderData[key];
      if (!imageUrl) continue;
  
      const thumbBtn = document.createElement('button');
      thumbBtn.classList.add('c-image-slider__thumb', 'o-media-container');
      if (index === 0) thumbBtn.classList.add('is-thumb-active');
  
      thumbBtn.setAttribute('data-media-thumb', '');
      thumbBtn.setAttribute('data-product-gallery-thumbnail', '');
  
      thumbBtn.innerHTML = `<img src="${imageUrl}" alt="Thumbnail ${index + 1}" />`;
  
      this.thumbnails.appendChild(thumbBtn);
      index++;
    }
  }

  private openLightbox() {
    try {
      if (!this.imageLightbox)
        throw "Missing lightbox element";

      const activeSlide = this.imageCarousel!.querySelector('.c-image-slider__item.is-active img') as HTMLImageElement;
      if (activeSlide && activeSlide.src && this.lightboxImage) {
        this.lightboxImage.innerHTML = `<img src="${activeSlide.src}"/>`;
        this.imageLightbox.visible = true;
      }

    } catch (error) {
      console.warn(error);
    }
  }
  
  // Function to toggle the CLASS_OPEN class on the root element (:host)
  private toggleModelViewer() {
    this.isOpen = !this.isOpen;
    this.classList.toggle('is-minimised', this.isOpen);
  }

  private onLightboxClose(e: Event) {
    try {
      e.stopPropagation();
      e.preventDefault();
      if (!this.imageLightbox)
        throw "Missing lightbox element";
      this.imageLightbox.visible = false;
    } catch (error) {
      console.warn(error);
    }
  }
}

if(!customElements.get('customiser-image-slider')) {
  customElements.define('customiser-image-slider', CustomiserImageSlider);
}